import React from "react";
import { Workflow, useBCMSContext, BCMSRecord, useParams } from "@bcm-dev/bcms-vite";
import { Trip, TravelPlan, Card } from "model";

import AddTravelPlanPage from "components/pages/AddTravelPlanPage";

const steps = [ <AddTravelPlanPage /> ];

/**
 * @function AddTravelPlanWorkflow
 * @returns {React.Component}
 * @description The main component for the travel plan workflow
 * @exported true
 * @example <AddTravelPlanWorkflow />
 */
export default function AddTravelPlanWorkflow(props) {
    const controller = useBCMSContext();
    const cardID = useParams().cardID ?? "0";

    const value = getDefaultTravelPlan(controller, cardID);
    return <Workflow value={ value } steps={ steps } />;
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Hook to return the steps of the workflow
 * @exported true
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultTravelPlan
 * @param {BCMSGlobalController} controller - The global controller instance from @bcm-dev/bcms-vite
 * @param {STRING} card - The id of the card from the parameter
 * @returns {OBJECT}
 * @exported true
 * @description Returns the default values for the travel plan
 */
export const getDefaultTravelPlan = (controller, card) => {
    BCMSRecord.globalControllerFor([ Trip, TravelPlan, Card ], controller);

    const trip = Trip.init({});
    const plan = TravelPlan.init({});

    trip.id = Trip.nextID();
    plan.id = TravelPlan.nextID();

    trip.travelPlanID = plan.id;
    plan.trip = trip.id;
    plan.status = "Active";
    plan.card = Card.initByID(card);

    return { trip, plan };
};